import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import { MusicClientContext } from '../../context/MusicClientContext';
import CustomTextInput from '../../../common/components/CustomTextInput';
import { MusicEntity } from '../../types/MusicEntityTypes';

function MusicUploadProgressBar({
  progress,
} : {
  progress: number,
}) {
  return (
    <div className="bar">
      <span className="percent" style={{ width: `${Math.floor(progress * 10) / 10}%` }} />
      <span className="percent_str">
        {progress}
        %
      </span>
    </div>
  );
}


export default function MusicUploadListItemView({
  uploadId, file, defaultPermissionToUse, onMusicCancel, onMusicSave,
} : {
  uploadId: string,
  file: File,
  defaultPermissionToUse: number,
  onMusicCancel: (uploadId: string) => void,
  onMusicSave: (uploadId: string, music: MusicEntity) => void,

}) {
  const stripExtension = (name: string) => {
    const re = /^(.*)\.(.*?)$/;
    if (!re.test(name)) return name;
    const matches = re.exec(name);
    if (matches === null) return name;
    return matches[1];
  };
  const [uploadStatus, setUploadStatus] = React.useState('beforeUpload');
  const [progress, setProgress] = React.useState(0);
  const [title, setTitle] = React.useState(stripExtension(file.name));
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [uploadHash, setUploadHash] = React.useState<string|null>(null);

  const {
    beginMusicUpload,
    commitMusicUpload,
    rollbackMusicUpload,
  } = React.useContext(MusicClientContext);

  React.useEffect(() => {
    if (uploadStatus !== 'beforeUpload') return;
    setUploadStatus('nowUploading');
    beginMusicUpload(file, (progressValue) => setProgress(progressValue)).then((data) => {
      setUploadStatus('editTitle');
      setUploadHash(data.music.upload_hash);
    }, (data) => {
      setErrorMessage(data.msg);
      setUploadStatus('uploadError');
    });
  });

  const saveMusic = () => {
    if (uploadHash === null) return;
    commitMusicUpload(uploadHash, title, defaultPermissionToUse).then((data) => {
      onMusicSave(uploadId, data.music);
    }, (data) => {
      setErrorMessage(data.msg);
    });
  };

  const deleteMusic = () => {
    if (uploadHash === null) return;
    rollbackMusicUpload(uploadHash).then(() => {
      onMusicCancel(uploadId);
    }, (data) => {
      setErrorMessage(data.msg);
    });
  };

  if (uploadStatus === 'beforeUpload') {
    return null;
  }

  return (
    <div className="upload_box">
      <dl>
        <dt><p className="file_title">{file.name}</p></dt>
        {uploadStatus === 'nowUploading' && (
          <>
            <div><p className="label_1">アップロード中...</p></div>
            <dd>
              <MusicUploadProgressBar progress={progress} />
            </dd>
          </>
        )}
        {uploadStatus === 'uploadError' && (
          <>
            <div><p className="label_2">エラー</p></div>
            <dd>{errorMessage}</dd>
          </>
        )}
        {uploadStatus === 'editTitle' && (
          <>
            <div><p className="label_2">アップロード完了</p></div>
            <dd>
              <span className="song_title">曲名：</span>
              <CustomTextInput
                value={title}
                setValue={(value) => setTitle(value)}
              />
            </dd>
          </>
        )}
      </dl>
      <ul>
        <li className="bt">
          {(uploadStatus === 'nowUploading' || uploadStatus === 'uploadError') && (
            <>
              <CustomButton type="cancel" onClick={() => onMusicCancel(uploadId)}>キャンセル</CustomButton>
            </>
          )}
          {(uploadStatus === 'editTitle') && (
            <>
              <CustomButton type="cancel-split" onClick={() => deleteMusic()}>曲の削除</CustomButton>
              <CustomButton type="default-split" onClick={() => saveMusic()}>保存</CustomButton>
            </>
          )}
        </li>
      </ul>
    </div>
  );
}
